<template>
  <div id="ns-prodotti" class="section std gallery d-flex is-justify-content-center is-align-items-center">
    <div class="section-container">
      <div class="content">
        <div class="container d-flex is-align-items-center">
          <div class="row ns-prod">
            <div class="col-md-12 ns-prod-titolo">
              <h2>{{ trans.get('public.home.our-products.our-products') }}</h2>
            </div>
            <div
                class="col-md-6 macro-cards"
                v-if="m.codice === 'NAS' || m.codice === 'CIN'"
                v-for="m in macrofamilies">
              <ns_card :macrofamiglia="m"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ns_card from "./ns-prodotti-card";

export default {
  name: "ns-prodotti.vue",
  components: {
    ns_card,
  },
  data() {
    return {
      macrofamilies: null,
    };
  },
  mounted() {
    this.getMacroFamilies();
  },
  methods: {
    getMacroFamilies: function () {
      axios({
        method: "get",
        url: window.location.origin + "/macrofamilies",
      }).then((res) => {
        this.macrofamilies = res.data[0];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  padding-top: 50px;
  margin-bottom: 100px;
}

.container {
  font-size: 1em;
  @media (min-width: 1921px){
    ffont-size: var(--font-size-large);
  }
  height: calc(100vh - 80px);
  background-color: #26262a;
  width: 100%;
  max-width: 100% !important;
  padding: 0;

  .row.ns-prod {
    width: 90%;
    max-width: 90%;
  }

  @media (max-width: 576px) {
    padding: 0;
  }

  h2 {
    color: #fff;
  }
}

@media (max-width: 576px) {
  .section {
    padding: 25px 0;
  }
  .container, .content, .section-container, .section.std {
    height: 100% !important;
  }
  .section-container {
    margin: 0;
    max-width: 100%;
  }
  .container {
    .ns-prod-titolo {
      padding: 0;
    }
  }
    .macro-cards {
      margin-bottom: 30px;
      padding-left: 0;
      padding-right: 0;
    }

    h2 {
      font-size: 18px;
      margin-bottom: 13px;
    }
  }

  @media (min-width: 1921px) {

  }
</style>
